module.exports = __webpack_public_path__ + "la.svg?a5d419e525f7d010a673fa78fc3dba3f";